<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/corporate/home">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/corporate/shop-live">Shop Live</a></li>
      <li class="breadcrumb-item active" aria-current="page">Corporate Library</li>
    </ol>
  </nav>
</div>

<div class="container mt-1 themeTblReso">
  <div class="row">
    <div class="col-md-3 col-xl-6 mb-md-0 mb-2">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text cyan lighten-2" id="basic-text1"><i class="fa fa-search text-white"
              aria-hidden="true"></i></span>
        </div>
        <input class="form-control" type="text" placeholder="Search" aria-label="Search" #searchText />
      </div>
    </div>

    <div class="col-md-3 col-xl-2 mb-md-0 mb-2" style="justify-content: right">
      <input type="button" value="Add New" class="custbtn mt-md-1 ml-0" routerLink="/corporate/shoplive-addpost" />
    </div>
  </div>
  <div class="row mt-2">

    <div class="col-md-3 mb-md-0 mb-2" *ngIf="companyID==0">
      <div>

        <select name="company" class="form-control formstyle" (change)="getProductList(); getCategoryData();getBusinessDomain()"
          [(ngModel)]="selectedCompany">
          <option value="">Select Company Name</option>
          <ng-container *ngFor="let userObj of getCompanyobj">
            <!-- <option *ngIf="userObj.dbstatus == true" value={{userObj.customer_id}}>
              {{ userObj.customer_company_name }}
            </option> -->
            <option value={{userObj.customer_id}}>
              {{ userObj.customer_company_name }}
            </option>
          </ng-container>
        </select>
      </div>
    </div>

    <div class="col-md-3 mb-md-0 mb-2">

      <div>
        <select name="company" class="form-control formstyle" (change)="getProByCategoryId($event.target.value)">
          <option value="0">Select Category</option>
          <ng-container *ngFor="let obj of categoryObj">
            <option value={{obj.sl_cat_id}}>
              {{obj.sl_cat_name}}
            </option>
          </ng-container>
        </select>
    </div>
    </div>
    <div class="col-md-3 mb-md-0 mb-2">
      <div>
        <select name="company" class="form-control formstyle" (change)="getListByDomainId($event.target.value)">
          <option value="0" selected disabled>Select Business Domain</option>
          <ng-container *ngFor="let obj of domainData">
            <option value={{obj.id}}>
              {{obj.domain_name}}
            </option>
          </ng-container>
        </select>
    </div>
    </div>
  </div>
  <div class="tblPrt">
    <table class="mt-1 bdrStCustom" width="100%" cellpadding="0" cellspacing="0" *ngIf="productObj.length > 0">
      <tr>
        <th (click)="setOrder('sl_product_name')" style="cursor: pointer">
          Post Name
          <i class="fa fa-sort text-black" aria-hidden="true"></i>
        </th>
        <th>Post Image</th>
        <th>Category Name</th>
        <th (click)="setOrder('createdon')" style="cursor: pointer">
          Created On<i class="fa fa-sort text-black" aria-hidden="true"></i>
        </th>
        <th>Actions</th>
      </tr>
      <tr *ngFor="
      let obj of productObj">
        <td>{{ obj.sl_product_name }}</td>
        <td>
          <img *ngIf="obj.imageType == 0" [src]="obj.sl_product_files" alt="Not Found" (error)="setValue($event)"
            style="height: 50px" />
          <img *ngIf="obj.imageType == 1" src="../../../../assets/images/doc_image.jpg"
            style="max-height: 35px; min-width: 35px;" />
          <!-- <video *ngIf="obj.imageType == 2" src="" poster="assets/images/icons/video-play.svg"
            style="max-height: 40px"></video> -->

            <div class="video" *ngIf="obj.imageType == 2">
              <div class="playbtn">
                <img  src="assets/images/icons/video-play.svg" alt="">
              </div>
              <video  [src]="obj.sl_product_files" (error)="setValue($event)"
              (click)="playFullscreen(videoPlayer)" #videoPlayer ></video>
            </div>
        </td>
        <td>{{obj.sl_cat_name}}</td>
        <td>{{ obj.createdon | date: "mediumDate" }}</td>
        <td>
          <div class="actBtn">
            <i class="fa fa-edit mr-1" (click)="editPost(obj.sl_product_id)" placement="bottom" ngbTooltip="Edit"
              *ngIf="isEdit"></i>
            <i *ngIf="isEdit" class="fa fa-trash mr-1" (click)="deleteProduct(obj.sl_product_id)" placement="bottom"
              ngbTooltip="Delete"></i>

            <mat-slide-toggle *ngIf="isEdit" class="my-slider" [checked]="obj.status"
              (click)="updateStatus($event, obj.sl_product_id, obj.status)">
            </mat-slide-toggle>
          </div>
        </td>
      </tr>
    </table>
  </div>

  <div class="mt-3" *ngIf="slTotal == 0" style="text-align: center">
    <p>No Result Available</p>
  </div>

  <div class="mt-2 text-center difPagination" *ngIf="slTotal > 10">
    <ngb-pagination [collectionSize]="slTotal" [(page)]="slPage" [maxSize]="2" [rotate]="true"
      (pageChange)="getProductList(slPage=$event)" aria-label="Custom pagination">
      <ng-template ngbPaginationPrevious>Prev</ng-template>
      <ng-template ngbPaginationNext>Next</ng-template>
    </ngb-pagination>
  </div>
</div>
